export const packagePlanActionTypes = {
    STORE_PACKAGE_PLANS: 'STORE_PACKAGE_PLANS',
    CLEAR_PACKAGE_PLANS: 'CLEAR_PACKAGE_PLANS',
} as const;
